// extracted by mini-css-extract-plugin
module.exports = {"block":"PremiumArticle_block__OI_dv","headline":"PremiumArticle_headline__os9De","icon":"PremiumArticle_icon__h3bNs","module":"PremiumArticle_module__VckEn"};